// removed by extract-text-webpack-plugin
module.exports = {"root":"_2KUEm","error":"_1OTha","warning":"_1WCfr","success":"qq18h"};


//////////////////
// WEBPACK FOOTER
// ../source/components/Callout/styles.css
// module id = 1442
// module chunks = 7 8 12